import React from 'react';
import styled from 'styled-components';
import { ArrowBack } from '@styled-icons/boxicons-regular';
import { useStore } from '../../context/appContext';

const Div = styled.div`
  width: auto;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: auto;
`;

const BackButton = styled.button`
  border: none;
`;

const Back = styled(ArrowBack)`
  width: 1.8rem;
  height: 1.8rem;
`;

const TopbarText = styled.h4`
  font-size: 1.3rem;
  padding-left: 1rem;
`;

function Topbar() {
  const { stepBackwards, step } = useStore();

  const handleBack = () => {
    if (step === 1) return;
    stepBackwards();
  };
  return (
    <Div>
      <BackButton onClick={handleBack}>
        <Back />
      </BackButton>
      <TopbarText>Volver</TopbarText>
    </Div>
  );
}

export default Topbar;
